import { CircleX, RefreshCw } from 'lucide-react';
import Button from './Button';
import Icon from './Icon';

// §2.6 Error state: what happened, then what to do. onRetry renders the one action.
export default function ErrorState({ title, message, onRetry, retryLabel = 'Try again' }) {
  return (
    <div className="ui ui-state ui-state--error" role="alert">
      <p className="ui-state__title"><Icon icon={CircleX} />{title}</p>
      <p className="ui-state__msg">{message}</p>
      {onRetry && <Button variant="secondary" icon={RefreshCw} onClick={onRetry}>{retryLabel}</Button>}
    </div>
  );
}
